module.exports = __webpack_public_path__ + "img/Seminario_Parsvakonasana.18e4c79f.png";